import PropTypes from 'prop-types';

import './disclaimer.scss';

const Disclaimer = ({ links, copyright }) => {
  const year = new Date().getFullYear();
  const copyrightText = `${copyright}, ${year}`;
  
  return (
    <div className="footer-disclaimer-container">
      <div className="footer-disclaimer">
        <ul className="footer-disclaimer__items">
          {links.map((link) => {
            return (
              <li className="footer-disclaimer__item" key={link.name}>
                <a href={link.href} rel={link.rel}>{link.name}</a>
              </li>
            );
          })}
          <li className="footer-disclaimer__item">{copyrightText}</li>
        </ul>
      </div>
    </div>
  );
};

Disclaimer.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      rel: PropTypes.string,
    }),
  ).isRequired,
  copyright: PropTypes.string.isRequired,
};

export default Disclaimer;
